const getComponentTopic = (state: AnyFixMe, compId: string) =>
  state.smartWriter[compId];

export const smartWriterSelectors = { getComponentTopic };
